<template>
<div id="kt_footer" class="footer py-4 d-flex flex-lg-column">
    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between" v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }">
        <div class="text-dark order-2 order-md-1">
            <span class="text-muted font-weight-bold mr-2">2022©</span>
            <a href="//perufedup.com" target="_blank" class="text-dark-75 text-hover-primary">PERUFEDUP</a>
        </div>
        <div class="nav nav-dark order-1 order-md-2">
            <a href="https://www.perufedup.com/nosotros/" target="_blank" class="nav-link pr-3 pl-0">Nosotros</a>
            <a href="#" target="_blank" class="nav-link px-3">Equipo</a>
            <a href="#" target="_blank" class="nav-link pl-3 pr-0">Contáctanos</a>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "KTFooter",
    computed: {
        ...mapGetters(["layoutConfig"]),
        widthFluid() {
            return this.layoutConfig("footer.width") === "fluid";
        }
    }
};
</script>
